import React, { ReactElement } from "react";

export default function Account(): ReactElement {
    return (
        <div>
            <h2>Account</h2>
        </div>
    );
}